export enum ProductionAuditEventType {
    AllowSharedAccess = 'AllowSharedAccessEvent',
    GetDownloadLinks = 'GetDownloadLinksEvent',
    GetDownloadLinksInvalid = 'GetDownloadLinksInvalidEvent',
    GetDownloadParts = 'GetDownloadPartsEvent',
    GetDownloadPartsNotFound = 'GetDownloadPartsNotFoundEvent',
    RemoveSharedAccess = 'RemoveSharedAccessEvent',
    SharedProductionDownload = 'SharedProductionDownloadEvent',
    SharedProductionLand = 'SharedProductionLandEvent',
    SharedProductionLandInvalid = 'SharedProductionLandInvalidEvent',
    SharedProductionLandExportAccessRemoved = 'SharedProductionLandExportAccessRemovedEvent',
    SharedProductionLandExportExpired = 'SharedProductionLandExportExpiredEvent',
    SharedProductionLandExportProductionDeleted = 'SharedProductionLandExportProductionDeletedEvent',
    VerificationCodeCodeInvalid = 'VerificationCodeCodeInvalidEvent',
    VerificationCodeCodeVerified = 'VerificationCodeCodeVerifiedEvent',
    VerificationCodeRequest = 'VerificationCodeRequestEvent',
    VerificationCodeRequestFailedToSendEmail = 'VerificationCodeRequestFailedToSendEmailEvent',
    Unknown = 'Unknown',
  }
  
  export const ProductionAuditEventDescriptions: Record<ProductionAuditEventType, string> = {
    [ProductionAuditEventType.AllowSharedAccess]: 'Shared access enabled.',
    [ProductionAuditEventType.GetDownloadLinks]: 'Shared download link click.',
    [ProductionAuditEventType.GetDownloadLinksInvalid]: 'Shared download links access denied.',
    [ProductionAuditEventType.GetDownloadParts]: 'Shared download password confirmed.',
    [ProductionAuditEventType.GetDownloadPartsNotFound]: 'Shared download password confirmed. Download Not Found.',
    [ProductionAuditEventType.RemoveSharedAccess]: 'Shared access removed.',
    [ProductionAuditEventType.SharedProductionDownload]: 'Shared production download base event.',
    [ProductionAuditEventType.SharedProductionLand]: 'Shared download link visited.',
    [ProductionAuditEventType.SharedProductionLandInvalid]: 'Shared download link visited. Link is invalid.',
    [ProductionAuditEventType.SharedProductionLandExportAccessRemoved]: 'Shared download link is no longer valid due to removed access.',
    [ProductionAuditEventType.SharedProductionLandExportExpired]: 'Shared download link visited. Link is expired.',
    [ProductionAuditEventType.SharedProductionLandExportProductionDeleted]: 'Shared download link visited. The production is deleted.',
    [ProductionAuditEventType.VerificationCodeCodeInvalid]: 'Email verification code is invalid.',
    [ProductionAuditEventType.VerificationCodeCodeVerified]: 'Email verification code verified.',
    [ProductionAuditEventType.VerificationCodeRequest]: 'Email verification code requested.',
    [ProductionAuditEventType.VerificationCodeRequestFailedToSendEmail]: 'Failed to send email with verification code.',
    [ProductionAuditEventType.Unknown]: 'This is an unknown event.'
  };
  